/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createAlova } from 'alova';
import AdapterUniapp from '@alova/adapter-uniapp';
import useAuthStore from '@/stores/auth';
import { assign } from 'lodash-es';
import pinia from '@/stores/store';
import router from '@/router';
import { API_BASE_URL } from '@/constant/vite_env';
import storage from './storage';
import { parseQuery, toAwait } from './tools';

// 请求头
const HEADER = {
    'Content-Type': 'application/json',
    'Menu-Scope-Code': 'mobile'
};

// 全局token状态
const authStore = useAuthStore(pinia);

// 刷新token实例
export const refreshTokenAlova = createAlova({
    // 请求根路径
    baseURL: API_BASE_URL,
    // 引入Uniapp适配器
    ...AdapterUniapp(),
    // 网络请求发送前的处理函数(拦截函数)
    beforeRequest(method) {
        method.config.headers = assign(method.config.headers, HEADER);
    },
    // 响应拦截器
    responded: {
        // 请求成功的拦截器
        onSuccess: async (response) => {
            // @ts-ignore
            const { statusCode, data: rawData } = response;
            // 请求成功
            if (statusCode === 200) {
                return rawData;
            }
            if (statusCode === 404) {
                return Promise.reject('找不到接口');
            }
            if (statusCode === 500) {
                return Promise.reject({
                    ...rawData,
                    message: rawData?.msg
                });
            }
            return Promise.reject(rawData);
        },
        // 请求失败的拦截器
        onError: (err, method) => {
            console.log(err);
            return Promise.reject({ err, method });
        }
    }
});

// 刷新token API
const refreshTokenPoster = refreshTokenAlova.Post<any>(
    `/auth/oauth/token?refresh_token=${storage.get('refreshToken')}&grant_type=refresh_token&scope=server`,
    {},
    {
        headers: {
            Authorization: 'Basic bW9iaWxlOm1vYmlsZQ=='
        }
    }
);

// 切换租户 API
const tenantTokenPoster = (userId: string) =>
    refreshTokenAlova.Post<any>(
        `/auth/account-grant/switch-user-v2/${userId}`,
        {},
        {
            headers: {
                Authorization: authStore.getAuthorization?.authorization
            }
        }
    );

// alova实例
export const alovaInstance = createAlova({
    // 请求根路径
    baseURL: API_BASE_URL,
    // 全局关闭缓存，需要的接口再独立配置Method
    localCache: null,
    // 引入Uniapp适配器
    ...AdapterUniapp(),
    // 超时设置为20秒
    timeout: 20000,
    // 网络请求发送前的处理函数(拦截函数)
    async beforeRequest(method) {
        if (!method.meta?.noToken) {
            method.config.headers = assign(method.config.headers, HEADER, authStore.getAuthorization);
        }
        const { wxTenantId, userId } = parseQuery();
        const tenantId = authStore.getToken ? window.atob(authStore.getToken).split('@')[1] : undefined;
        if (wxTenantId && userId && wxTenantId !== tenantId) {
            const [err, res] = await toAwait(tenantTokenPoster(userId).send(true));
            if (err) {
                authStore.deleteToken();
                return router.replaceAll({ name: 'login' });
            }
            authStore.setToken(res?.data?.access_token, res?.data?.refresh_token);
            method.config.headers = assign(method.config.headers, HEADER, {
                authorization: `bearer ${res?.data?.access_token}`
            });
        }
    },
    // 响应拦截器
    responded: {
        // 请求成功的拦截器
        onSuccess: async (response, method) => {
            console.log(response);
            const { config } = method;
            const { enableDownload, enableUpload, requestType } = config;
            console.log(config);

            // @ts-ignore
            const { statusCode, data: rawData, tempFilePath } = response;
            if (requestType === 'download') {
                return tempFilePath;
            }
            const { code, msg, data } = rawData;
            // 没有接口权限的处理
            if (statusCode === 403) {
                return router.push({ name: '403' });
            }
            // token 过期处理
            if (statusCode === 424 && !method.meta?.noToken) {
                console.log(authStore.getToken, method.config, '过期处理');
                if (!authStore.getToken) {
                    return router.replaceAll({ name: 'login' });
                }
                const [err, res] = await toAwait(refreshTokenPoster.send(true));
                if (err) {
                    authStore.deleteToken();
                    return router.replaceAll({ name: 'login' });
                }
                authStore.setToken(res?.access_token, res?.refresh_token);
                const [error, result] = await toAwait(method.send(true));
                if (error) {
                    return Promise.reject(result);
                }
                return result;
            }
            // 请求成功
            if (statusCode === 200) {
                if (requestType === 'download') {
                    return tempFilePath;
                }
                if (enableDownload) {
                    // 下载处理
                    return rawData;
                }
                if (enableUpload) {
                    // 上传处理
                    return rawData;
                }
                if (code === 0) {
                    return data;
                }

                if (code === undefined) {
                    return response;
                }

                return Promise.reject({
                    ...rawData,
                    message: rawData?.msg
                });
            }
            if (statusCode === 404) {
                return Promise.reject('找不到接口');
            }
            if (statusCode === 500) {
                return Promise.reject({
                    ...rawData,
                    message: rawData?.msg
                });
            }
            return Promise.reject(rawData);
        },
        // 请求失败的拦截器
        onError: (err, method) => {
            console.log(err);
            return Promise.reject({ err, method });
        }
    }
});
